// Mock Payment Data - İNSAET
// Gelir ve gider kayıtları

export const mockPayments = [
    // ==================== YEŞİL PARK - GELİRLER ====================
    {
        id: 'pay1',
        constructionId: 'c1',
        apartmentId: 'a1',
        personId: 'ind-1',
        type: 'income',
        category: 'Daire Satışı',
        amount: 2500000,
        date: '2025-06-15',
        description: 'A-1 dairesi tam ödeme - Emre Karaca',
    },
    {
        id: 'pay2',
        constructionId: 'c1',
        apartmentId: 'a2',
        personId: 'ind-2',
        type: 'income',
        category: 'Kapora',
        amount: 500000,
        date: '2026-03-01',
        description: 'A-2 dairesi kapora - Sevgi Korkmaz',
    },
    {
        id: 'pay3',
        constructionId: 'c1',
        apartmentId: 'a4',
        personId: 'ind-3',
        type: 'income',
        category: 'Daire Satışı',
        amount: 1900000,
        date: '2025-07-20',
        description: 'A-4 dairesi tam ödeme - Hüseyin Aktaş',
    },
    {
        id: 'pay4',
        constructionId: 'c1',
        apartmentId: 'a5',
        personId: 'ind-6',
        type: 'income',
        category: 'Kapora',
        amount: 1000000,
        date: '2025-08-01',
        description: 'A-5 dairesi kapora - Elif Tuncer',
    },
    {
        id: 'pay5',
        constructionId: 'c1',
        apartmentId: 'a7',
        personId: 'ind-9',
        type: 'income',
        category: 'Daire Satışı',
        amount: 3500000,
        date: '2025-08-30',
        description: 'A-7 Penthouse tam ödeme - Oğuz Yalçın',
    },
    {
        id: 'pay6',
        constructionId: 'c1',
        apartmentId: 'a9',
        personId: 'ind-6',
        type: 'income',
        category: 'Daire Satışı',
        amount: 2200000,
        date: '2025-05-10',
        description: 'B-1 dairesi tam ödeme - Elif Tuncer',
    },
    {
        id: 'pay7',
        constructionId: 'c1',
        apartmentId: 'a15',
        personId: 'ind-11',
        type: 'income',
        category: 'Daire Satışı',
        amount: 3200000,
        date: '2025-09-15',
        description: 'B-7 dubleks tam ödeme - Tolga Başaran',
    },

    // ==================== YEŞİL PARK - GİDERLER ====================
    {
        id: 'pay8',
        constructionId: 'c1',
        apartmentId: null,
        personId: 'comp-1',
        type: 'expense',
        category: 'Malzeme',
        amount: 850000,
        date: '2025-03-10',
        description: 'Demir ve çimento alımı - Demir Yapı İnşaat',
    },
    {
        id: 'pay9',
        constructionId: 'c1',
        apartmentId: null,
        personId: null,
        type: 'expense',
        category: 'İşçilik',
        amount: 250000,
        date: '2026-03-01',
        description: 'Mart ayı işçi maaşları',
    },
    {
        id: 'pay10',
        constructionId: 'c1',
        apartmentId: null,
        personId: 'comp-2',
        type: 'expense',
        category: 'Tesisat',
        amount: 180000,
        date: '2025-04-05',
        description: 'Elektrik tesisat işleri - Yıldırım Elektrik',
    },
    {
        id: 'pay11',
        constructionId: 'c1',
        apartmentId: null,
        personId: 'comp-3',
        type: 'expense',
        category: 'Tesisat',
        amount: 120000,
        date: '2025-05-15',
        description: 'Sıhhi tesisat işleri - Akar Tesisat',
    },
    {
        id: 'pay12',
        constructionId: 'c1',
        apartmentId: null,
        personId: null,
        type: 'expense',
        category: 'İşçilik',
        amount: 250000,
        date: '2026-04-01',
        description: 'Nisan ayı işçi maaşları',
    },

    // ==================== MAVİ DENİZ - GELİRLER ====================
    {
        id: 'pay13',
        constructionId: 'c2',
        apartmentId: 'a17',
        personId: 'ind-4',
        type: 'income',
        category: 'Daire Satışı',
        amount: 3200000,
        date: '2025-08-15',
        description: 'A-1 dairesi tam ödeme - Derya Güneş',
    },
    {
        id: 'pay14',
        constructionId: 'c2',
        apartmentId: 'a18',
        personId: 'ind-4',
        type: 'income',
        category: 'Kapora',
        amount: 2500000,
        date: '2025-07-15',
        description: 'A-2 dairesi kapora - Derya Güneş',
    },
    {
        id: 'pay15',
        constructionId: 'c2',
        apartmentId: 'a21',
        personId: 'ind-5',
        type: 'income',
        category: 'Daire Satışı',
        amount: 3800000,
        date: '2025-09-20',
        description: 'A-5 dairesi tam ödeme - Burak Özdemir',
    },
    {
        id: 'pay16',
        constructionId: 'c2',
        apartmentId: 'a28',
        personId: 'ind-11',
        type: 'income',
        category: 'Kapora',
        amount: 4500000,
        date: '2025-10-01',
        description: 'A-12 Penthouse kapora - Tolga Başaran',
    },
    {
        id: 'pay17',
        constructionId: 'c2',
        apartmentId: 'a29',
        personId: 'ind-10',
        type: 'income',
        category: 'Daire Satışı',
        amount: 3000000,
        date: '2025-08-01',
        description: 'B-1 dairesi tam ödeme - Ceren Aksoy',
    },

    // ==================== MAVİ DENİZ - GİDERLER ====================
    {
        id: 'pay18',
        constructionId: 'c2',
        apartmentId: null,
        personId: 'comp-1',
        type: 'expense',
        category: 'Malzeme',
        amount: 1200000,
        date: '2025-07-10',
        description: 'Beton ve demir alımı - Demir Yapı İnşaat',
    },
    {
        id: 'pay19',
        constructionId: 'c2',
        apartmentId: null,
        personId: null,
        type: 'expense',
        category: 'İşçilik',
        amount: 380000,
        date: '2025-07-01',
        description: 'Temmuz ayı işçi maaşları',
    },
    {
        id: 'pay20',
        constructionId: 'c2',
        apartmentId: null,
        personId: 'comp-2',
        type: 'expense',
        category: 'Tesisat',
        amount: 280000,
        date: '2025-08-20',
        description: 'Elektrik tesisat işleri - Yıldırım Elektrik',
    },
];

// Helper functions
export const getPaymentsByConstructionId = (constructionId) => {
    if (!constructionId) return mockPayments;
    return mockPayments.filter(p => p.constructionId === constructionId);
};

export const getPaymentsByType = (type, constructionId) => {
    let payments = constructionId
        ? mockPayments.filter(p => p.constructionId === constructionId)
        : mockPayments;
    return payments.filter(p => p.type === type);
};

export const getPaymentStats = (constructionId) => {
    const payments = constructionId
        ? mockPayments.filter(p => p.constructionId === constructionId)
        : mockPayments;
    const income = payments.filter(p => p.type === 'income');
    const expense = payments.filter(p => p.type === 'expense');
    return {
        totalIncome: income.reduce((sum, p) => sum + p.amount, 0),
        totalExpense: expense.reduce((sum, p) => sum + p.amount, 0),
        incomeCount: income.length,
        expenseCount: expense.length,
    };
};

export default mockPayments;
